import React from 'react'
import PropTypes from 'prop-types'

// components
import { Widget } from "quorumdesign"
import FavoriteAndRecentUserActionsViewer from 'favorites/containers/FavoriteAndRecentUserActionsViewer'

// helpers
import { parseHtmlToReact } from "app/static/frontend/imports/desktopHelperFunctions"

const FavoriteSearchesWidget = ({
    description,
    favorites,
    editForm,
    editing,
    headerIcons,
    headerTitle,
    isExternal,
    widgetKey,
}) => (
    <Widget
        description={description && parseHtmlToReact(description, widgetKey, false)}
        editing={editing}
        headerIcons={headerIcons}
        headerTitle={headerTitle}
        id={widgetKey && `widget-${widgetKey}`}
        noHeader={!headerTitle}
        widget={
            !isExternal
            && <FavoriteAndRecentUserActionsViewer
                inWidget
                editing={editing || editForm}
                showOnlyFavorites={favorites}
                showOnlyRecents={!favorites}
            />
        }
        widgetFallback={isExternal && "This widget is not supported in external dashboards"}
        widgetKey={widgetKey}
    />
)

FavoriteSearchesWidget.defaultProps = {}

FavoriteSearchesWidget.propTypes = {
    description: PropTypes.string,
    favorites: PropTypes.bool,
    editForm: PropTypes.bool,
    editing: PropTypes.bool,
    headerIcons: PropTypes.array,
    headerTitle: PropTypes.string,
    isExternal: PropTypes.bool,
    widgetKey: PropTypes.string,
}

export default FavoriteSearchesWidget
